/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { initialState } from "./part-time-employee-constant";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import { leaveValidationSchema } from "../leave-policy-validation";

const usePartTimeEmployeeService = ({ openSnackbar }) => {
    const [leave, setLeave] = useState(initialState);
    const [leaveListsInfo, setLeaveListsInfo] = useState([]);
    const [errors, setErrors] = useState({});

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 2,
        total: 0,
        totalPages: 1,
    });

    const { fetchData } = useAPIHandler();

    async function leaveLists(page = 1, pageSize = 20) {
        try {
            const URL = `/organization/leave-policy?page=${page}&pageSize=${pageSize}&for_emp=part_time`;
            const METHOD = "GET";

            const result = await fetchData({ url: URL, method: METHOD });

            setLeaveListsInfo(result?.data?.orgLeavePolicy || []);
            setPagination({
                page: result?.data?.pagination?.page || 1,
                pageSize: result?.data?.pagination?.pageSize || 2,
                total: result?.data?.pagination?.total || 0,
                totalPages: result?.data?.pagination?.totalPages || 1,
            });
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching leave policies", color: "danger" });
        }
    }

    const handleChange = (e, name) => {
        const value = e?.target ? e.target.value : e;
        const fieldName = e?.target ? e.target.name : name;

        setLeave((prev) => ({ ...prev, [fieldName]: value }));

        const updatedState = { ...leave, [fieldName]: value };

        const { error } = leaveValidationSchema.validate(updatedState, { abortEarly: false });

        const newErrors = error
            ? error.details.reduce((acc, curr) => {
                acc[curr.path[0]] = curr.message;
                return acc;
            }, {})
            : {};

        setErrors(newErrors);
    };

    const handleBlurFn = (e, name) => {
        const value = e?.target ? e.target.value : e;
        const updatedState = { ...leave, [name]: value };

        const { error } = leaveValidationSchema.validate(updatedState, { abortEarly: false });

        const newErrors = error
            ? error.details.reduce((acc, curr) => {
                acc[curr.path[0]] = curr.message;
                return acc;
            }, {})
            : {};

        setErrors(newErrors);
    };

    const handleSubmit = async () => {
        try {
            const { leave_type_id, leave_days, unuse_leave, cf_limit } = leave;
            const { error } = leaveValidationSchema.validate({ leave_type_id, leave_days, unuse_leave, cf_limit }, { abortEarly: false });

            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                    acc[err.path.join(".")] = err.message;
                    return acc;
                }, {})
                : {};

            setErrors(validationErrors);

            if (Object.keys(validationErrors).length > 0) {
                return false;
            }

            const response = await fetchData({
                url: "/organization/create-leave-policy",
                method: "POST",
                data: { ...leave, for_emp: "part_time" },
            });

            if (response.status === "success") {
                setLeave(initialState);
                openSnackbar({
                    message: "Leave Policy Created Successfully",
                    color: "success",
                });
                leaveLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };

    const handleUpdate = async (id) => {
        const { leave_type_id, leave_days, unuse_leave, cf_limit } = leave;
        const { error } = leaveValidationSchema.validate(
            { leave_type_id, leave_days, unuse_leave, cf_limit },
            { abortEarly: false }
        );

        const validationErrors = error
            ? error.details.reduce((acc, err) => {
                acc[err.path.join(".")] = err.message;
                return acc;
            }, {})
            : {};

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return false;
        }

        try {
            const response = await fetchData({
                url: `/organization/modify-leave-policy/${id}`,
                method: "POST",
                data: {
                    leave_type_id,
                    leave_days,
                    unuse_leave,
                    cf_limit,
                    for_emp: "part_time"
                },
            });

            if (response.status === "success") {
                setLeave(initialState);
                openSnackbar({ message: "Leave Policy Updated Successfully", color: "success" });
                leaveLists();
                return true;
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };

    const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = error.errors.reduce((acc, curr) => {
                acc[curr.field] = curr.message;
                return acc;
            }, {});

            openSnackbar({
                message: Object.keys(errorsAll).length > 0 ? "Validation Error!" : "Something went wrong!",
                color: "danger",
            });
            setErrors(errorsAll);
        }if (error?.type === "GeneralError") {
            openSnackbar({ message: error.message, color: "danger" });
        } else {
            const backendMessage = typeof error.message === "string" ? error.message : "An unexpected error occurred.";
            openSnackbar({ message: backendMessage, color: "danger" });
        }

        logger.log(error);
    };

    useEffect(() => {
        leaveLists();
    }, []);

    return {
        leaveLists,
        leaveListsInfo,
        pagination,
        errors,
        setErrors,
        leave,
        setLeave,
        handleChange,
        handleBlurFn,
        handleSubmit,
        handleUpdate,
    };
};

export default usePartTimeEmployeeService;
